import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useWrappedCompanions from './useWrappedCompanions';

const useUnstakedCompanions = () => {
  const { account } = useWeb3React();
  const companions = useWrappedCompanions();

  const [unstakedCompanions, setUnstakedCompanions] = useState([]);

  useEffect(() => {
    let ignore = false;
    setUnstakedCompanions([]);
    if (companions) {
      const fetchCompanions = () => {
        companions.walletOfOwner(account).then((tokenIds) => {
          if (!ignore)
            setUnstakedCompanions(
              tokenIds.map((tokenId) => tokenId.toNumber())
            );
        });
      };
      fetchCompanions();
      const transferFrom = companions.filters.Transfer(account);
      const transferTo = companions.filters.Transfer(null, account);
      companions.on(transferFrom, fetchCompanions);
      companions.on(transferTo, fetchCompanions);
      return () => {
        companions.off(transferFrom, fetchCompanions);
        companions.off(transferTo, fetchCompanions);
        ignore = true;
      };
    }
  }, [companions, account]);

  return unstakedCompanions;
};

export default useUnstakedCompanions;
